export default __webpack_public_path__ + "static/protected-environment-9da668536e12a2fa73bb1a013ff9d45f.webp";